// src/components/Deliveryzones/Deliveryzones.js
import React, { useState, useEffect, useCallback } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_URL;

const INDIAN_STATES = [
    'Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh',
    'Goa','Gujarat','Haryana','Himachal Pradesh','Jharkhand','Karnataka',
    'Kerala','Madhya Pradesh','Maharashtra','Manipur','Meghalaya','Mizoram',
    'Nagaland','Odisha','Punjab','Rajasthan','Sikkim','Tamil Nadu','Telangana',
    'Tripura','Uttar Pradesh','Uttarakhand','West Bengal',
    'Andaman and Nicobar Islands','Chandigarh','Dadra and Nagar Haveli and Daman and Diu',
    'Delhi','Jammu and Kashmir','Ladakh','Lakshadweep','Puducherry'
];

const DZ_STYLES = `
    .dz-page { padding: 24px; background: #F0F4FA; min-height: 100vh; font-family: inherit; }

    /* Table wrapper — matches .km-table-wrap */
    .dz-card { background: #fff; border-radius: 12px; border: 1px solid #e5e7eb; overflow: hidden; }

    /* Table head — matches your data-table thead */
    .dz-table { width: 100%; border-collapse: collapse; }
    .dz-table thead tr { background: #fff; }
    .dz-table th { padding: 12px 16px; text-align: left; font-size: 12px; font-weight: 600; color: #6b7280; border-bottom: 1px solid #e5e7eb; text-transform: none; letter-spacing: 0; }

    /* Table rows — matches .data-table td */
    .dz-table td { padding: 12px 16px; font-size: 13px; color: #374151; border-bottom: 1px solid #f3f4f6; background: #fff; vertical-align: middle; }
    .dz-table tbody tr:last-child td { border-bottom: none; }
    .dz-table tbody tr:hover td { background: #f9fafb; }

    /* ID column — matches .td-id */
    .dz-num-col { color: #9ca3af; font-size: 12px; width: 50px; }

    /* Search — matches .search-input */
    .dz-search { flex:1; min-width:180px; padding: 9px 14px; border: 1px solid #e5e7eb; border-radius: 8px; font-size: 13px; outline: none; color: #111827; background: #fff; }
    .dz-search:focus { border-color: #9ca3af; }

    /* Add button — matches .tbBtn.btnPrimary */
    .dz-btn-add { padding: 9px 18px; background: #0C3B8C; color: #fff; border: none; border-radius: 8px; font-size: 13px; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 6px; white-space: nowrap; }
    .dz-btn-add:hover { opacity: .88; }

    /* Section header — matches .section-header */
    .dz-controls { display: flex; gap: 10px; margin-bottom: 16px; flex-wrap: wrap; align-items: center; }

    /* Section title — matches .section-title */
    .dz-topbar { display:flex; align-items:center; justify-content:space-between; margin-bottom:20px; }
    .dz-title { font-size: 18px; font-weight: 600; color: #111827; }
    .dz-subtitle { font-size: 12px; color: #6B7280; margin-top: 3px; }

    /* Stats */
    .dz-stats { display:flex; gap:10px; margin-bottom:20px; flex-wrap:wrap; }
    .dz-stat { background:#fff; border-radius:8px; padding:12px 18px; flex:1; min-width:120px; border:1px solid #E5E7EB; }
    .dz-stat-val { font-size:22px; font-weight:600; color:#111827; line-height:1; }
    .dz-stat-lbl { font-size:11px; color:#9CA3AF; margin-top:4px; text-transform:uppercase; letter-spacing:.05em; }

    /* State tag */
    .dz-state-tag { display:inline-block; padding:2px 9px; background:#F3F4F6; color:#6B7280; border-radius:20px; font-size:11px; font-weight:500; cursor:pointer; }

    /* Badges */
    .dz-badge { display:inline-flex; align-items:center; gap:4px; padding:2px 9px; border-radius:20px; font-size:11px; font-weight:600; }
    .dz-badge-active   { background:#ECFDF5; color:#065F46; }
    .dz-badge-inactive { background:#FFF7ED; color:#9A3412; }

    /* Charge */
    .dz-charge { font-size: 13px; font-weight: 600; color: #374151; }
    .dz-charge-free { color: #065F46; }

    /* Action buttons */
    .dz-act-row { display:flex; gap:6px; }
    .dz-btn-edit { padding:4px 12px; background:transparent; color:#6B7280; border:1px solid #E5E7EB; border-radius:7px; font-size:12px; font-weight:500; cursor:pointer; }
    .dz-btn-edit:hover { background:#F3F4F6; color:#111827; }
    .dz-btn-del { padding:4px 12px; background:transparent; color:#DC2626; border:1px solid #FECACA; border-radius:7px; font-size:12px; font-weight:500; cursor:pointer; }
    .dz-btn-del:hover { background:#FEF2F2; }

    /* Empty / loader — matches .km-empty, .km-loading */
    .dz-empty { text-align: center; padding: 40px 24px; color: #9CA3AF; font-size: 13px; }
    .dz-empty-icon { font-size: 36px; margin-bottom: 8px; }
    .dz-loader { text-align: center; padding: 40px; color: #9CA3AF; font-size: 13px; }

    .dz-filter-info { font-size:12px; color:#9CA3AF; margin-bottom:10px; }
    .dz-filter-info strong { color:#374151; }
    .dz-clear-filter { font-size:12px; color:#DC2626; cursor:pointer; text-decoration:underline; margin-left:8px; }

    /* Modal */
    .dz-overlay { position:fixed; inset:0; background:rgba(0,0,0,.4); z-index:9998; display:flex; align-items:center; justify-content:center; padding:16px; }
    .dz-modal { background:#fff; border-radius:12px; width:100%; max-width:400px; border:1px solid #E5E7EB; overflow:hidden; animation:dz-pop .2s ease; }
    @keyframes dz-pop { from{opacity:0;transform:scale(.96)} to{opacity:1;transform:scale(1)} }
    .dz-modal-hd { background:#F9FAFB; padding:14px 18px; display:flex; justify-content:space-between; align-items:center; border-bottom:1px solid #E5E7EB; }
    .dz-modal-title { font-size:14px; font-weight:600; color:#111827; }
    .dz-modal-close { background:none; border:none; color:#9CA3AF; font-size:20px; cursor:pointer; line-height:1; padding:0; }
    .dz-modal-close:hover { color:#374151; }
    .dz-modal-body { padding:18px; }
    .dz-modal-field { margin-bottom:14px; }
    .dz-modal-lbl { font-size:12px; font-weight:600; color:#6B7280; margin-bottom:6px; display:block; }
    .dz-modal-input { width:100%; padding:9px 12px; border:1px solid #E5E7EB; border-radius:8px; font-size:13px; color:#111827; outline:none; box-sizing:border-box; font-family:inherit; background:#fff; }
    .dz-modal-input:focus { border-color:#9CA3AF; }
    .dz-modal-select { width:100%; padding:9px 12px; border:1px solid #E5E7EB; border-radius:8px; font-size:13px; color:#111827; outline:none; box-sizing:border-box; font-family:inherit; background:#fff; appearance:none; background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%239CA3AF' viewBox='0 0 256 256'%3E%3Cpath d='M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z'/%3E%3C/svg%3E"); background-repeat:no-repeat; background-position:right 12px center; cursor:pointer; }
    .dz-modal-select:focus { border-color:#9CA3AF; }
    .dz-modal-err { font-size:12px; color:#DC2626; margin-bottom:10px; }

    .dz-toggle-row { display:flex; align-items:center; gap:10px; margin-bottom:14px; }
    .dz-toggle-lbl { font-size:13px; font-weight:500; color:#374151; }
    .dz-switch { position:relative; width:36px; height:20px; flex-shrink:0; }
    .dz-switch input { opacity:0; width:0; height:0; }
    .dz-slider { position:absolute; inset:0; background:#E5E7EB; border-radius:20px; cursor:pointer; transition:background .2s; }
    .dz-slider::before { content:''; position:absolute; width:14px; height:14px; left:3px; top:3px; background:#fff; border-radius:50%; transition:transform .2s; }
    input:checked + .dz-slider { background:#059669; }
    input:checked + .dz-slider::before { transform:translateX(16px); }

    .dz-modal-footer { display:flex; justify-content:flex-end; gap:8px; padding:0 18px 18px; }
    .dz-btn-cancel { padding:8px 16px; background:transparent; color:#6B7280; border:1px solid #E5E7EB; border-radius:8px; font-size:13px; font-weight:500; cursor:pointer; }
    .dz-btn-save { padding:8px 20px; background:#0C3B8C; color:#fff; border:none; border-radius:8px; font-size:13px; font-weight:600; cursor:pointer; }
    .dz-btn-save:hover { opacity:.88; }
    .dz-btn-save:disabled { opacity:.4; cursor:not-allowed; }

    /* Confirm dialog */
    .dz-confirm-overlay { position:fixed; inset:0; background:rgba(0,0,0,.4); z-index:9999; display:flex; align-items:center; justify-content:center; padding:16px; }
    .dz-confirm-box { background:#fff; border-radius:12px; padding:24px 20px 18px; max-width:320px; width:100%; border:1px solid #E5E7EB; text-align:center; }
    .dz-confirm-icon { font-size:36px; margin-bottom:10px; }
    .dz-confirm-title { font-size:15px; font-weight:600; color:#111827; margin-bottom:6px; }
    .dz-confirm-text { font-size:13px; color:#9CA3AF; margin-bottom:18px; }
    .dz-confirm-btns { display:flex; gap:8px; justify-content:center; }
    .dz-confirm-cancel { padding:8px 18px; background:transparent; color:#6B7280; border:1px solid #E5E7EB; border-radius:8px; font-size:13px; font-weight:500; cursor:pointer; }
    .dz-confirm-delete { padding:8px 18px; background:#FEF2F2; color:#DC2626; border:1px solid #FECACA; border-radius:8px; font-size:13px; font-weight:600; cursor:pointer; }

    @media(max-width:640px) {
        .dz-table th:nth-child(5), .dz-table td:nth-child(5) { display:none; }
    }
`;
// ─── Confirm Dialog (replaces Swal for delete) ───────────────────────────────
const ConfirmDialog = ({ district, onConfirm, onCancel }) => (
    <div className="dz-confirm-overlay" onClick={onCancel}>
        <div className="dz-confirm-box" onClick={e => e.stopPropagation()}>
            <div className="dz-confirm-icon">🗑️</div>
            <div className="dz-confirm-title">Delete Zone?</div>
            <div className="dz-confirm-text">"{district}" will be removed permanently.</div>
            <div className="dz-confirm-btns">
                <button className="dz-confirm-cancel" onClick={onCancel}>Cancel</button>
                <button className="dz-confirm-delete" onClick={onConfirm}>Yes, Delete</button>
            </div>
        </div>
    </div>
);

// ─── DataTable ────────────────────────────────────────────────────────────────
const DataTable = ({ columns, rows, query, setQuery, onAdd, addLabel = '+ Add', filterInfo, renderRow, loading, emptyText = 'No items found.' }) => (
    <>
        <div className="dz-controls">
            <input
                className="dz-search"
                placeholder="Search district…"
                value={query}
                onChange={e => setQuery(e.target.value)}
            />
            {onAdd && (
                <button className="dz-btn-add" onClick={onAdd}>{addLabel}</button>
            )}
        </div>
        {filterInfo}
        <div className="dz-card">
            {loading ? (
                <div className="dz-loader">Loading…</div>
            ) : rows.length === 0 ? (
                <div className="dz-empty">
                    <div className="dz-empty-icon">📭</div>
                    <p>{emptyText}</p>
                </div>
            ) : (
                <table className="dz-table">
                    <thead><tr>{columns.map(col => <th key={col}>{col}</th>)}</tr></thead>
                    <tbody>{rows.map((row, i) => renderRow(row, i))}</tbody>
                </table>
            )}
        </div>
    </>
);

// ─── Main Component ───────────────────────────────────────────────────────────
const EMPTY_FORM = { state: '', district: '', charge: '', is_active: true };

const DeliveryZones = ({ showToast }) => {
    const [zones,         setZones]         = useState([]);
    const [loading,       setLoading]       = useState(true);
    const [search,        setSearch]        = useState('');
    const [selectedState, setSelectedState] = useState('');
    const [modal,         setModal]         = useState(false);
    const [editing,       setEditing]       = useState(null);
    const [form,          setForm]          = useState(EMPTY_FORM);
    const [formErr,       setFormErr]       = useState('');
    const [saving,        setSaving]        = useState(false);
    const [confirmZone,   setConfirmZone]   = useState(null); // zone pending delete

    const fetchZones = useCallback(async () => {
        setLoading(true);
        try {
            const res  = await fetch(`${API_BASE_URL}/delivery-zones`);
            const data = await res.json();
            setZones(Array.isArray(data) ? data : []);
        } catch { setZones([]); }
        finally { setLoading(false); }
    }, []);

    useEffect(() => { fetchZones(); }, [fetchZones]);

    const statesInData = [...new Set(zones.map(z => z.state).filter(Boolean))].sort();

    const openCreate = () => {
        setEditing(null);
        setForm({ ...EMPTY_FORM, state: selectedState || '' });
        setFormErr('');
        setModal(true);
    };

    const openEdit = (zone) => {
        setEditing(zone);
        setForm({
            state:     zone.state     || '',
            district:  zone.district,
            charge:    String(zone.charge),
            is_active: zone.is_active,
        });
        setFormErr('');
        setModal(true);
    };

    const closeModal = () => { setModal(false); setFormErr(''); };

    const handleSave = async () => {
        if (!form.state.trim())    { setFormErr('Please select a state.'); return; }
        if (!form.district.trim()) { setFormErr('District name is required.'); return; }
        if (form.charge === '' || isNaN(parseFloat(form.charge)) || parseFloat(form.charge) < 0) {
            setFormErr('Enter a valid delivery charge (0 or more).'); return;
        }
        setSaving(true); setFormErr('');
        try {
            const method = editing ? 'PUT' : 'POST';
            const url    = editing
                ? `${API_BASE_URL}/delivery-zones/${editing.id}`
                : `${API_BASE_URL}/delivery-zones`;
            const res  = await fetch(url, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ ...form, charge: parseFloat(form.charge) }),
            });
            const data = await res.json();
            if (!data.success) { setFormErr(data.message || 'Failed to save.'); return; }
            closeModal();
            await fetchZones();
            showToast(
                editing ? 'Zone Updated!' : 'Zone Added!',
                `"${form.district}" saved successfully.`
            );
        } catch { setFormErr('Server error. Try again.'); }
        finally { setSaving(false); }
    };

    // Show confirm dialog instead of Swal
    const handleDelete = (zone) => setConfirmZone(zone);

    const confirmDelete = async () => {
        const zone = confirmZone;
        setConfirmZone(null);
        try {
            const res  = await fetch(`${API_BASE_URL}/delivery-zones/${zone.id}`, { method: 'DELETE' });
            const data = await res.json();
            if (data.success) {
                setZones(prev => prev.filter(z => z.id !== zone.id));
                showToast('Deleted!', `"${zone.district}" removed successfully.`);
            } else {
                showToast('Delete Failed', 'Could not delete this zone.');
            }
        } catch {
            showToast('Server Error', 'Something went wrong. Try again.');
        }
    };

    // ── Filtering ─────────────────────────────────────────────────────────────
    const filtered = zones.filter(z => {
        const matchState  = selectedState ? z.state === selectedState : true;
        const matchSearch = z.district.toLowerCase().includes(search.toLowerCase());
        return matchState && matchSearch;
    });

    // ── Stats ─────────────────────────────────────────────────────────────────
    const activeCount = zones.filter(z => z.is_active).length;
    const freeCount   = zones.filter(z => parseFloat(z.charge) === 0).length;
    const avgCharge   = zones.length
        ? (zones.reduce((s, z) => s + parseFloat(z.charge), 0) / zones.length).toFixed(0)
        : 0;

    const columns  = ['#', 'State', 'District', 'Delivery Charge', 'Status', 'Actions'];

    const renderRow = (zone, idx) => (
        <tr key={zone.id}>
            <td style={{ color: '#7A90B0', fontSize: 12 }}>{idx + 1}</td>
            <td>
                <span
                    className="dz-state-tag"
                    style={{ cursor: 'pointer' }}
                    onClick={() => setSelectedState(zone.state || '')}
                    title={`Filter by ${zone.state}`}
                >
                    {zone.state || '—'}
                </span>
            </td>
            <td><strong>{zone.district}</strong></td>
            <td>
                <span className={`dz-charge ${parseFloat(zone.charge) === 0 ? 'dz-charge-free' : ''}`}>
                    {parseFloat(zone.charge) === 0 ? 'Free' : `₹${parseFloat(zone.charge).toFixed(2)}`}
                </span>
            </td>
            <td>
                <span className={`dz-badge ${zone.is_active ? 'dz-badge-active' : 'dz-badge-inactive'}`}>
                    {zone.is_active ? '● Active' : '○ Inactive'}
                </span>
            </td>
            <td>
                <div className="dz-act-row">
                    <button className="dz-btn-edit" onClick={() => openEdit(zone)}>Edit</button>
                    <button className="dz-btn-del"  onClick={() => handleDelete(zone)}>Delete</button>
                </div>
            </td>
        </tr>
    );

    const filterInfo = (selectedState || search) ? (
        <div className="dz-filter-info">
            Showing <strong>{filtered.length}</strong> result{filtered.length !== 1 ? 's' : ''}
            {selectedState && <> in <strong>{selectedState}</strong></>}
            {search && <> matching "<strong>{search}</strong>"</>}
            <span className="dz-clear-filter" onClick={() => { setSelectedState(''); setSearch(''); }}>
                ✕ Clear filters
            </span>
        </div>
    ) : null;

    return (
        <div className="dz-page">
            <style>{DZ_STYLES}</style>

            {/* ── Confirm Delete Dialog ──────────────────────────────────────── */}
            {confirmZone && (
                <ConfirmDialog
                    district={confirmZone.district}
                    onConfirm={confirmDelete}
                    onCancel={() => setConfirmZone(null)}
                />
            )}

            {/* ── Modal ─────────────────────────────────────────────────────── */}
            {modal && (
                <div className="dz-overlay" onClick={closeModal}>
                    <div className="dz-modal" onClick={e => e.stopPropagation()}>
                        <div className="dz-modal-hd">
                            <span className="dz-modal-title">
                                {editing ? 'Edit Zone' : 'Add Delivery Zone'}
                            </span>
                            <button className="dz-modal-close" onClick={closeModal}>×</button>
                        </div>
                        <div className="dz-modal-body">
                            <div className="dz-modal-field">
                                <label className="dz-modal-lbl">State *</label>
                                <select
                                    className="dz-modal-select"
                                    value={form.state}
                                    onChange={e => { setForm(p => ({ ...p, state: e.target.value })); setFormErr(''); }}
                                >
                                    <option value="">— Select State —</option>
                                    {INDIAN_STATES.map(s => <option key={s} value={s}>{s}</option>)}
                                </select>
                            </div>
                            <div className="dz-modal-field">
                                <label className="dz-modal-lbl">District Name *</label>
                                <input
                                    className="dz-modal-input"
                                    placeholder="e.g. Trichy"
                                    value={form.district}
                                    onChange={e => { setForm(p => ({ ...p, district: e.target.value })); setFormErr(''); }}
                                    autoFocus
                                />
                            </div>
                            <div className="dz-modal-field">
                                <label className="dz-modal-lbl">Delivery Charge (₹) *</label>
                                <input
                                    className="dz-modal-input"
                                    type="number" min="0" step="0.01"
                                    placeholder="0 = Free delivery"
                                    value={form.charge}
                                    onChange={e => { setForm(p => ({ ...p, charge: e.target.value })); setFormErr(''); }}
                                />
                            </div>
                            {formErr && <div className="dz-modal-err">⚠ {formErr}</div>}
                            <div className="dz-toggle-row">
                                <span className="dz-toggle-lbl">Active</span>
                                <label className="dz-switch">
                                    <input
                                        type="checkbox"
                                        checked={form.is_active}
                                        onChange={e => setForm(p => ({ ...p, is_active: e.target.checked }))}
                                    />
                                    <span className="dz-slider" />
                                </label>
                                <span style={{ fontSize: 12, color: form.is_active ? '#2E7D32' : '#E65100', fontWeight: 600 }}>
                                    {form.is_active ? 'Visible in checkout' : 'Hidden from checkout'}
                                </span>
                            </div>
                        </div>
                        <div className="dz-modal-footer">
                            <button className="dz-btn-cancel" onClick={closeModal}>Cancel</button>
                            <button className="dz-btn-save" onClick={handleSave} disabled={saving}>
                                {saving ? 'Saving…' : editing ? 'Update Zone' : 'Add Zone'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

           

            {/* ── Stats ─────────────────────────────────────────────────────── */}
            <div className="dz-stats">
                <div className="dz-stat" style={{ borderColor: '#1A52A8' }}>
                    <div className="dz-stat-val">{zones.length}</div>
                    <div className="dz-stat-lbl">Total Zones</div>
                </div>
                <div className="dz-stat" style={{ borderColor: '#2E7D32' }}>
                    <div className="dz-stat-val">{activeCount}</div>
                    <div className="dz-stat-lbl">Active</div>
                </div>
                <div className="dz-stat" style={{ borderColor: '#43A047' }}>
                    <div className="dz-stat-val">{freeCount}</div>
                    <div className="dz-stat-lbl">Free Delivery</div>
                </div>
                <div className="dz-stat" style={{ borderColor: '#F57C00' }}>
                    <div className="dz-stat-val">₹{avgCharge}</div>
                    <div className="dz-stat-lbl">Avg Charge</div>
                </div>
                <div className="dz-stat" style={{ borderColor: '#6A1B9A' }}>
                    <div className="dz-stat-val">{statesInData.length}</div>
                    <div className="dz-stat-lbl">States</div>
                </div>
            </div>

            {/* ── DataTable ─────────────────────────────────────────────────── */}
            <DataTable
                columns={columns}
                rows={filtered}
                query={search}
                setQuery={setSearch}
                onAdd={openCreate}
                addLabel="+ Add Zone"
                filterInfo={filterInfo}
                renderRow={renderRow}
                loading={loading}
                emptyText={selectedState ? `No zones found in ${selectedState}.` : 'No zones found.'}
            />
        </div>
    );
};

export default DeliveryZones;